<template>
  <div>
    <div class="row">
      <div class="col-6">
        <div>
          <Calendar/>
        </div>
        <div class="mt-2">
          <Widget>
            <PendingPrescriptions :doctor="getUser.doctor"/>
          </Widget>
        </div>
      </div>
      <div class="col-6">
        <div>
          <Widget>
            <UpcomingAppointments :doctor="getUser.doctor"/>
          </Widget>
        </div>
        <div class="mt-2">
          <Widget>
            <MissedCheckups :doctor="getUser.doctor"/>
          </Widget>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import Calendar from './../../../components/doctor/Calendar/Calendar'
import UpcomingAppointments from './../../../components/doctor/UpcomingAppointments/UpcomingAppointments'
import PendingPrescriptions from './../../../components/doctor/PendingPrescriptions/PendingPrescriptions'
import MissedCheckups from "@/components/doctor/MissedCheckups/MissedCheckups";

export default {
  name: "Appointments",
  components: {
    MissedCheckups,
    Calendar,
    UpcomingAppointments,
    PendingPrescriptions
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('doctorAuth', ['getUser']),
  },
  methods: {},
  mounted() {
  }

}
</script>

<style scoped>

</style>
